const isHorizon = document.querySelector(".page-template-horizon");
const isSoundQuiz = document.querySelector(".page-template-sound-quiz");

if (isHorizon || isSoundQuiz) {
    const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    //Play Button Handler

    const stopAllSounds = () => {
        document.querySelectorAll("audio").forEach((audio) => {
            audio.pause();
        });
        document.querySelectorAll(".card__play-button").forEach((play) => {
            play.classList.contains("card__play-button--active") && play.classList.remove("card__play-button--active");
            const parentContainer = play.closest(".sound-simulator__card");
            parentContainer.classList.remove("playing");
        });
    };

    document.querySelectorAll(".io-button__toggle").forEach((button) => {
        let ready = false;
        button.addEventListener("click", (e) => {
            const parentContainer = button.closest(".sound-simulator__card");
            ready = parentContainer.dataset.ready === "true";

            if (ready) {
                parentContainer.querySelector(".card__effect-box .card__tooltip").style.display = "none";

                let loaded = false;
                const soundUntouched = parentContainer.querySelector(".soundUntouched");
                const soundProcessed = parentContainer.querySelector(".soundProcessed");
                const input = parentContainer.querySelector("input");
                const box = input.parentElement.parentElement;

                input.disabled = false;

                if (input.checked) {
                    if (isIOS) {
                        soundUntouched.muted = false;
                        soundProcessed.muted = true;

                        if (!loaded) {
                            soundUntouched.paused && soundUntouched.play();
                            loaded = true;
                        }
                    } else {
                        soundUntouched.volume = 1;
                        soundProcessed.volume = 0;
                    }

                    box.classList.remove(`${box.classList[0]}--active`);
                } else {
                    if (isIOS) {
                        soundUntouched.muted = true;
                        soundProcessed.muted = false;

                        if (!loaded) {
                            soundProcessed.paused && soundProcessed.play();
                            loaded = true;
                        }
                    } else {
                        soundUntouched.volume = 0;
                        soundProcessed.volume = 1;
                    }

                    box.classList.add(`${box.classList[0]}--active`);
                    box.classList.add("fired");
                }
            }
        });
    });

    document.querySelectorAll(".card__play-button").forEach((play, index) => {
        const parentContainer = play.closest(".sound-simulator__card");
        const soundUntouched = play.parentElement.querySelector(".soundUntouched");
        const soundProcessed = play.parentElement.querySelector(".soundProcessed");
        const bar = play.parentElement.querySelector(".card__bar");

        if (isIOS) {
            soundUntouched.muted = false;
            soundProcessed.muted = true;
        } else {
            soundUntouched.volume = 1;
            soundProcessed.volume = 0;
        }

        soundUntouched.addEventListener("timeupdate", () => {
            let progress = soundUntouched.currentTime / soundUntouched.duration;
            bar.value = progress;
            progress == 1 && play.classList.remove("card__play-button--active");
        });

        play.addEventListener("click", () => {
            parentContainer.dataset.ready = "true";
            parentContainer.querySelector(".card__audio-player .card__tooltip").style.display = "none";
            if (play.classList.contains("card__play-button--active")) {
                soundUntouched.pause();
                soundProcessed.pause();
            } else {
                play.parentElement.querySelector("progress").style.opacity = "";
                stopAllSounds();
                soundProcessed.play();
                soundUntouched.play();
            }
            play.classList.toggle("card__play-button--active");

            !parentContainer.classList.contains("play") && parentContainer.classList.add("play");
            parentContainer.classList.toggle("playing");
        });
    });
}
function findParent(el, cls) {
    while ((el = el.parentElement) && !el.classList.contains(cls));
    return el;
}

//Sound card accordion
document.querySelectorAll(".card__copy-title").forEach((accordion) => {
    accordion.addEventListener("click", (e) => {
        const parent = findParent(accordion, "sound-simulator__card");
        parent.querySelector(".card__copy").classList.toggle("card__copy--active");
        accordion.classList.toggle("card__copy-title--active");
    });
});

var bgParallax = document.querySelectorAll(".page-template-horizon .parallax");

/* Background image paralax */

document.addEventListener("scroll", function () {
    let scrollPosition = window.pageYOffset;
    bgParallax &&
        bgParallax.forEach((parallax) => {
            const parallaxTop = parallax.getBoundingClientRect().top;
            const positionPercent = (parallaxTop * 100) / window.innerHeight;
            const parallaxHeightPercent = (parallax.offsetHeight * 100) / window.innerHeight;
            const rate = 0.7;

            if (scrollPosition > parallax.offsetTop && scrollPosition >= parallaxTop) {
                parallax.style.backgroundPositionY = 100 - parallaxHeightPercent * rate - positionPercent * rate + "%";
            } else {
                parallax.style.backgroundPositionY = "50%";
            }
        });
});

document.addEventListener("DOMContentLoaded", () => {
    if (!isHorizon) return;
    const tabBtns = document.querySelectorAll(".tabs__button");
    const tabs = document.querySelector(".tabs__content").querySelectorAll(".sound-simulator__card");
    tabBtns.forEach((btn) => btn.addEventListener("click", changeTab));

    function changeTab() {
        tabBtns.forEach((btn) => btn.classList.remove("active"));
        this.classList.toggle("active");

        const selectedMode = this.dataset.mode;

        tabs.forEach((tab) => tab.classList.remove("active"));
        document.querySelector(`.sound-simulator__card--${selectedMode}`).classList.add("active");
    }
});
